(function () {
  'use strict';

  var INIT_ATTR = 'data-subs-initialized';

  function getRefs(wrap) {
    return {
      freqSelect: wrap.querySelector('[data-frequency-select]'),
      freqRadios: wrap.querySelectorAll('[data-frequency-radio]'),
      subscribePrice: wrap.querySelector('[data-subscribe-price]'),
      subscribeToggle: wrap.querySelector('[data-subscribe-toggle]'),
      onetimeInput: wrap.querySelector('input[data-toggles-group][value=""]'),
    };
  }

  function getSelectedFreq(refs) {
    if (refs.freqRadios.length) {
      for (var i = 0; i < refs.freqRadios.length; i++) {
        if (refs.freqRadios[i].checked) return refs.freqRadios[i];
      }
      return null;
    }
    if (refs.freqSelect) return refs.freqSelect.options[refs.freqSelect.selectedIndex] || null;
    return null;
  }

  function setFreqDisabled(refs, disabled) {
    if (refs.freqRadios.length) {
      for (var i = 0; i < refs.freqRadios.length; i++) refs.freqRadios[i].disabled = disabled;
    } else if (refs.freqSelect) {
      refs.freqSelect.disabled = disabled;
    }
  }

  function hasFreqSelection(refs) {
    if (refs.freqRadios.length) return !!getSelectedFreq(refs);
    return refs.freqSelect && !!refs.freqSelect.value;
  }

  function selectFirstFreq(refs) {
    if (refs.freqRadios.length) {
      refs.freqRadios[0].checked = true;
    } else if (refs.freqSelect && refs.freqSelect.options.length) {
      refs.freqSelect.selectedIndex = 0;
    }
  }

  function dispatchFreqChange(refs) {
    var sel = getSelectedFreq(refs);
    if (refs.freqRadios.length) {
      if (sel) sel.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (refs.freqSelect) {
      refs.freqSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function syncSelectedPrice(refs) {
    var selected = getSelectedFreq(refs);
    if (!selected) return;

    var price = selected.getAttribute('data-plan-price');
    if (refs.subscribePrice && price) {
      refs.subscribePrice.textContent = price;
    }

    var groupId = selected.getAttribute('data-plan-group');
    if (groupId && refs.subscribeToggle) {
      refs.subscribeToggle.value = groupId;
    }
  }

  function updateState(wrap) {
    var refs = getRefs(wrap);
    var isOnetime = refs.onetimeInput && refs.onetimeInput.checked;

    wrap.querySelectorAll('.product__subs__option').forEach(function (opt) {
      opt.classList.remove('is-active');
    });

    if (isOnetime) {
      var onetimeOption = refs.onetimeInput.closest('.product__subs__option');
      if (onetimeOption) onetimeOption.classList.add('is-active');
      setFreqDisabled(refs, true);
      dispatchFreqChange(refs);
    } else {
      if (refs.subscribeToggle) {
        var subscribeOption = refs.subscribeToggle.closest('.product__subs__option');
        if (subscribeOption) subscribeOption.classList.add('is-active');
      }
      setFreqDisabled(refs, false);
      if (!hasFreqSelection(refs)) selectFirstFreq(refs);
      dispatchFreqChange(refs);
    }
  }

  function initModal(wrap) {
    var modal = wrap.parentElement ? wrap.parentElement.querySelector('[data-subs-modal]') : null;
    if (!modal || modal.hasAttribute(INIT_ATTR)) return;
    modal.setAttribute(INIT_ATTR, '');

    var lockScroll = function () {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    };
    var unlockScroll = function () {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };
    var openModal = function () {
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
      lockScroll();
    };
    var closeModal = function () {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
      unlockScroll();
    };

    wrap.parentElement.querySelectorAll('[data-open-subs-modal]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    });
    modal.querySelectorAll('[data-close-subs-modal]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    modal.addEventListener('close', unlockScroll);
    modal.addEventListener('cancel', unlockScroll);
  }

  function initWrap(wrap) {
    if (wrap.hasAttribute(INIT_ATTR)) return;
    wrap.setAttribute(INIT_ATTR, '');

    var refs = getRefs(wrap);

    var subscribeGroup = refs.subscribeToggle ? refs.subscribeToggle.closest('.product__subs__group') : null;
    if (subscribeGroup) {
      subscribeGroup.addEventListener('mousedown', function () {
        if (refs.subscribeToggle && !refs.subscribeToggle.checked) {
          refs.subscribeToggle.checked = true;
          updateState(wrap);
        }
      });
    }

    wrap.addEventListener('change', function (e) {
      if (e.target.name === 'selling-plan-group') {
        setTimeout(function () {
          updateState(wrap);
        }, 0);
      } else if (e.target.name === 'selling_plan') {
        syncSelectedPrice(getRefs(wrap));
      }
    });

    updateState(wrap);
    syncSelectedPrice(refs);
    initModal(wrap);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-subscription-selectors]').forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('theme:popup:open', function () {
    initAll();
  });
})();
